import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {Schedule} from "@/entity/Schedule"

export const getScheduleList = async () => {
  const result = await apiBase.get(`/schedules`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((s) => {
    return new Schedule(s);
  })
}

export const getScheduleListOf = async ({ userId }) => {
  const result = await apiBase.get(`/schedules/user/${userId}`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((s) => {
    return new Schedule(s);
  })
}

export const getScheduleDateOf = async ({ date }) => {
  const result = await apiBase.get(`/schedules/${date}`, {})
  return new Schedule(camelcaseKeys(result.data.data, { deep: true }))
}

export const addSchedule = async ({ schedule }) => {
  const result = await apiBase.post(`/schedules`, {...schedule.export()})
  const data = await result
  return new Schedule(camelcaseKeys(data.data, { deep: true }))
}

export const updateSchedule = async ({ id, schedule }) => {
  const result = await apiBase.put(`/schedules/${id}`, schedule.export())
  const data = await result
  return new Schedule(camelcaseKeys(data.data, { deep: true }))
}

export const deleteSchedule = async ({ id }) => {
  await apiBase.delete(`/schedules/${id}`)
}

export const exportSchedule = async () => {
  return apiBase.get(`/schedules/export`, {}, { responseType: 'blob' })
}

export const importSchedule = async ({ content }) => {
  return apiBase.put(`/schedules/import`, content)
}
